import {IAttrs} from "@ok/utils/types/IAttrs";
import React, {PropsWithChildren} from "react";
import {SvgIcon} from "../../../modules/svgIcon/SvgIcon";
import {IIconParams, IIconSize, createRootClassName} from "./lib/iconHelpers";
import {IconAsImage} from "./mob/IconAsImage";
import {TextIcon} from "./mob/TextIcon";

export interface ILazyIconProps extends IIconParams, PropsWithChildren {
    name: string;
    title?: string;
    size: IIconSize,
    imageClassName?: string;
    textClassName?: string
}

const Stub: React.FC<{
    title?: string;
    size: IIconSize;
    className?: string
    attrs?: IAttrs
}> =
    ({title, size, attrs, className}) => {
        let sizeInt = Number(size);
        return <span className={className} title={title} style={{width: sizeInt, height: sizeInt}} {...attrs} />;
    };

/**
 * @see "Руководство 'Как вставить иконку' находится в /manuals/ICONS.md"
 */
export class LazyIcon extends React.PureComponent<ILazyIconProps> {
    mounted = false;

    static defaultProps = {
        size: '16'
    };

    /* @todo: dmitrylapynov: MOL-14364: Переделать LazyIconsCache на 2 параметра name и icon вместо конкатенации */
    get fullIconName() {
        let {name, size} = this.props;
        return `${name}__${size}`;
    }

    onLoad = () => {
        if (this.mounted) {
            this.forceUpdate();
        }
    };

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
        SvgIcon.removeListener(this.fullIconName, this.onLoad);
    }

    render() {
        const {title, size, textClassName, children} = this.props;

        const name = this.fullIconName;
        const icon = SvgIcon.getContent(name);
        const attrs: IAttrs = {
            ...this.props.attrs,
            "data-icon-name": name,
        };

        let rootClassName = createRootClassName(this.props);

        if (!icon) {
            SvgIcon.load(name, this.onLoad);
        } else {
            let fontOrSpriteClass = icon.fontCssClass || icon.spriteCssClass;
            if (fontOrSpriteClass) {
                let { fontCssClass, spriteCssClass } = icon;
                attrs["data-icon-font"] = fontCssClass;
                attrs["data-icon-sprite"] = spriteCssClass;

                return (
                    <TextIcon modifierSupplier={rootClassName}
                              fontIconCssClass={fontCssClass}
                              spriteIconCssClass={spriteCssClass}
                              textClassName={textClassName}
                              title={title}
                              size={size}
                              attrs={attrs}
                    >
                        {children}
                    </TextIcon>
                );
            }

            if (icon.imgUrl) {
                attrs["data-icon-src"] = icon.imgUrl;

                return (
                    <IconAsImage
                        modifierSupplier={rootClassName}
                        imgClassName={this.props.imageClassName}
                        imageSrc={icon.imgUrl}
                        title={title}
                        size={size}
                        attrs={attrs}
                    >
                        {children}
                    </IconAsImage>
                );
            }
        }


        return (
            <Stub className={rootClassName} title={title} size={size} attrs={attrs}/>
        );
    }
}
